import { RichTextSpan, parseRichText } from 'bff'
import { Fragment } from 'react'
import { cn } from '../lib/cn'

const markClassName = (span: RichTextSpan) =>
  cn(
    span.bold && 'font-semibold',
    span.italic && 'italic',
    span.underline && 'underline',
  )

/**
 * Texto editable con el formato liviano del editor de plantillas
 * (`*negrita*`, `_cursiva_`, `__subrayado__`). Sin marcas imprime el mismo
 * nodo de texto que antes de existir el formato.
 */
export const RichText = ({ text }: { text: string }) => (
  <>
    {parseRichText(text).map((span, index) => {
      const className = markClassName(span)

      return className ? (
        <span key={index} className={className}>
          {span.text}
        </span>
      ) : (
        <Fragment key={index}>{span.text}</Fragment>
      )
    })}
  </>
)
